import React, { useEffect, useState } from 'react';
import styles from './StripeSection.module.scss';
import DomainVerificationIcon from '@mui/icons-material/DomainVerification';
import clsx from 'clsx';

const StripeProcessing = ({
	selected,
	hide,
	openVerificationModal,
	handleTogleStripe,
	isLead,
}) => {
	const [status, setStatus] = useState('');
	useEffect(() => {
		let identification = selected?.identification?.verification?.status;
		setStatus(identification);
	}, [selected]);

	if (status === 'requires_input')
		return (
			<span
				className={styles.txt_Processing}
				onClick={openVerificationModal}
			>
				ID Processing
			</span>
		);
	else if (status === 'verified' || status === 'manually_verified')
		return (
			<>
				<span
					className={styles.txt_Verified}
					onClick={openVerificationModal}
				>
					Verified&nbsp;
					{selected?.identification?.verification?.date}
				</span>
				{isLead ? (
					<DomainVerificationIcon
						className={clsx(
							styles.btnIcon_verification,
							hide ? null : styles.hide
						)}
						onClick={() => handleTogleStripe()}
					/>
				) : (
					<DomainVerificationIcon
						className={clsx(
							styles.btnIcon_verification,
							hide ? null : styles.active
						)}
						onClick={() => handleTogleStripe()}
					/>
				)}
			</>
		);
	else if (status === 'document_err' || status === 'selfie_err')
		return (
			<span className={styles.txt_Failed} onClick={openVerificationModal}>
				Failed Verification
			</span>
		);
	else
		return (
			<span
				onClick={openVerificationModal}
				className={styles.txt_VerifyId}
			>
				Verify ID
			</span>
		);
};

export default StripeProcessing;
